import React, { useEffect } from 'react';

import { useChangeLanguage } from '@lyearn/i18n';
import OnBoardingFlow from '@/components/OnBoardingFlow';
import PageLayout from '@/components/PageLayout';
import { useAppConfig } from '@/hooks/useAppConfig';
import useNavigation from '@/hooks/useNavigation';
import useNotification from '@/hooks/useNotification';
import { useUserContext } from '@/modules/auth/hooks/useUser';
import useJobByCreator from '@/modules/corporate/modules/admin/hooks/useJobByCreator';
import authRoutes from '@/pages/auth/routes';

const AppRoutes: React.FC<React.PropsWithChildren> = ({ children }) => {
  const user = useUserContext();
  const navigation = useNavigation();
  const {
    ui: { isUnifiedSidebar },
  } = useAppConfig();
  useJobByCreator();
  useNotification();
  useChangeLanguage(user.meta?.locale);
  const isVerifyEmail =
    window.location.pathname == authRoutes.VerifyEmail() ||
    window.location.pathname == authRoutes.VerifyEmailV2();
  // Unified login/signup page covers both AI-onboarding and classic workspaces
  // (the signup tab itself branches on isUserOnboardingAiEnabled), so every
  // logged-out user now lands on the Log in tab by default.
  const loggedOutRoute = authRoutes.Login();
  useEffect(() => {
    if (!user.id && !isVerifyEmail) {
      navigation.push(loggedOutRoute, { setFrom: true, appendQuery: false });
    }
  }, [navigation, user.id, isVerifyEmail, loggedOutRoute]);

  if (!user.id && !isVerifyEmail) {
    return null;
  }

  return (
    <OnBoardingFlow>
      {isUnifiedSidebar ? children : <PageLayout>{children}</PageLayout>}
    </OnBoardingFlow>
  );
};

export default AppRoutes;
